import { SET_GRAPH_TICKS } from './types';

export const setGraphTicks = graphTicks => ({ type: SET_GRAPH_TICKS, graphTicks });
